import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Icon } from '@/lib/icons';
import { useApp } from '@/contexts/AppContext';
import { onConsentChange, readConsent } from '@/lib/analytics/consent';

export function DataPolicyFAB() {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();
  const location = useLocation();
  const [hovered, setHovered] = useState(false);
  const currentLang = lang || 'fr';
  const { t } = useApp();
  // The cookie panel sits in the same corner: the button waits until the
  // visitor has answered it, so the two never overlap.
  const [consentAnswered, setConsentAnswered] = useState(() => readConsent() !== null);
  useEffect(() => (consentAnswered ? undefined : onConsentChange(() => setConsentAnswered(true))), [consentAnswered]);

  // Hide on the data-policy page (it would only reload it) and on the home
  // pages, whose footer already links the policy: the round button covered
  // the start of the section titles while scrolling.
  const path = location.pathname.replace(/\/+$/, '');
  const onHome = path === `/${currentLang}` || path === `/${currentLang}/site` || path === `/${currentLang}/dashboard`;
  if (!consentAnswered || onHome || location.pathname.includes('/data-policy')) {
    return null;
  }

  return (
    <div
      className="fixed left-4 bottom-4 z-40"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Tooltip: fades + slides up when hovered */}
      <div className={`absolute bottom-14 left-0 pointer-events-none transition-all duration-200 ease-premium ${hovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-1'}`}>
        <div className="relative surface-2 text-foreground text-xs font-medium px-3 py-1.5 rounded-md whitespace-nowrap">
          {t.dataPolicy}
          <span className="absolute -bottom-1 left-5 w-2 h-2 bg-popover border-r border-b border-border/70 rotate-45" />
        </div>
      </div>

      {/* Button: single accent, subtle border, hover shift only */}
      <button
        type="button"
        onClick={() => navigate(`/${currentLang}/data-policy`)}
        aria-label={t.dataPolicy}
        className={`interactive w-11 h-11 rounded-full surface-2 flex items-center justify-center focus-ring ${
          hovered ? 'text-yodi-orange border-yodi-orange/40' : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        <Icon name="shield" className="w-5 h-5" />
      </button>
    </div>
  );
}
